module.exports = __webpack_public_path__ + "img/big.6b7737ce.jpg";